import src from "IMAGE";
export default { src, width: 70, height: 70, blurWidth: 0, blurHeight: 0};
